import createApiInstance from '../../utils/createApiInstance';
import { USER_INFO_URL } from '../../constants/URLs';
import { UserInfo } from '../../../types/user/UserInfo';
import { AxiosResponse } from 'axios';
import { NotificationsTypes } from '../../../types/user/NotificationsTypes';

const userServiceInstance = createApiInstance(USER_INFO_URL);

export class UserService {
    private constructor() {}

    static async getUserInfo(): Promise<UserInfo> {
        const response: AxiosResponse = await userServiceInstance.get('');

        return response.data;
    }

    static async updateNotificationsType(notifications_type: NotificationsTypes) {
        await userServiceInstance.patch('', {
            notifications_type,
        });
    }
}
